var mapStyles = require('./mapStyles');

const $form = $('.js-find-a-store-search-map-form');
const $introductionContent = $('.js-find-a-store-introduction-content');
const $results = $('.js-store-search-results');
const $resultsSection = $('.js-store-search-map-results-section');
const $loader = $('.js-stores-loader');
const $useMyLocation = $('.js-get-current-location-map');
const $findAStoreModule = $('.js-find-a-store');
const $siteHeader = $('.js-site-header');
const $topBar = $('.js-top-bar');

const selectors = {
	backButton: '.js-stores-search-back-button',
    viewMoreButton: '.js-stores-search-view-more-locations-button',
};

const findAStore = {
    map: null,
    markers: [],
    
    initMap() {
        // Create map in the find-a-store section
        const mapContainer = document.querySelector('.js-find-a-store-map');
        
        if (!mapContainer) return;
        
        // Initialise Google Map with default center (United Kingdom)
        this.map = new google.maps.Map(mapContainer, {
            center: { lat: 54.7023545, lng: -3.2765753 }, // Default to center of UK
            zoom: 6,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: mapStyles
        });
    },

    // New function to add markers for store locations
    addMarkersToMap(stores, shouldFocusOnFirst = false) {
        // Preserve the current center and zoom if not an initial search
        const currentCenter = this.map.getCenter();
        const currentZoom = this.map.getZoom();
    
        // Clear existing markers
        this.clearMarkers();
    
        if (!stores || !stores.length) return;
    
        const bounds = new google.maps.LatLngBounds();
        const infoWindow = new google.maps.InfoWindow();
    
        // Create markers for each location
        stores.forEach((store, index) => {
            const position = new google.maps.LatLng(
                parseFloat(store.getAttribute('data-lat')),
                parseFloat(store.getAttribute('data-long'))
            );
    
            // Get store name for marker info
            const storeName = store.querySelector('.js-store-title').textContent;
            const storeLinkElement = store.querySelector('.js-store-link');
            const storePageLink = storeLinkElement ? storeLinkElement.getAttribute('href') : '#';
    
            // Create marker
            const marker = new google.maps.Marker({
                position,
                map: this.map,
                title: storeName,
                icon: {
                    url: WP.template_path + '/images/clarity-logo-pin-rounded.png',
                    size: new google.maps.Size(55, 67),
                    scaledSize: new google.maps.Size(55, 67)
                }
            });
    
            google.maps.event.addListener(marker, 'click', () => {
                infoWindow.setContent(`<div class="map-info-window"><a href="${storePageLink}" class="u-text-base">${storeName}</a></div>`);
                infoWindow.open(this.map, marker);
    
                // Open the corresponding accordion item
                const storeElement = $(`.js-accordion-item[data-index="${index + 1}"]`);
                if (!storeElement.attr('open')) {
                    storeElement.attr('open', true);
                    storeElement.find('.js-store-results-toggle-text').text('Hide');
                }
            });
    
            // Add marker to collection for later reference
            this.markers.push(marker);
    
            // Extend bounds to include this marker
            bounds.extend(position);
        });
    
        // If it's an initial search, focus on the first marker
        if (shouldFocusOnFirst && this.markers.length > 0) {
            this.map.setCenter(this.markers[0].getPosition());
            this.map.setZoom(15);
        } else {
            // Restore the previous center and zoom
            this.map.setCenter(currentCenter);
            this.map.setZoom(currentZoom);
        }
    },    
    
    // Clear all markers from the map
    clearMarkers() {
        this.markers.forEach(marker => marker.setMap(null));
        this.markers = [];
    },
    
    // Focus map on a specific marker
    focusMarker(index) {
        if (this.markers[index]) {
            this.map.setCenter(this.markers[index].getPosition());
            this.map.setZoom(15);
        }
    },

    // Set min-height for the Find A Store module
    setMinHeight() {
        if ($(window).width() > 1025) {
            const $siteHeaderHeight = $siteHeader.outerHeight();
            const $topBarHeight = $topBar.outerHeight();
            const $siteHeaderAndTopBarHeight = $siteHeaderHeight + $topBarHeight;
            
            $findAStoreModule.css({
                'min-height': `calc(100vh - ${$siteHeaderAndTopBarHeight}px)`,
            });
        } else {
            // Optionally reset the min-height if screen width is less than 1025px
            $findAStoreModule.css({
                'min-height': '',
            });
        }
    },
    
    doSearch() {
        this.initMap();
        var self = this;
        const data = $form.serialize();
        
        $resultsSection.show();
        $results.empty();
        $loader.show();
        $form.hide();
        $introductionContent.hide();
    
        $.ajax({
            url: WP.ajaxurl,
            data: data,
        }).done(response => {
            $loader.hide();
            $results.html(response);
            
            // After results are loaded, add markers to the map and focus on the first location
            setTimeout(() => {
                const storeElements = document.querySelectorAll('.js-accordion-item:not(.u-remove)');
                self.addMarkersToMap(storeElements, true);
            }, 300);
        });
    },

    init() {

        $resultsSection.on('click', selectors.backButton, e => {
            $resultsSection.hide();
            $form.show();
            $introductionContent.show();
        });

        $resultsSection.on('click', selectors.viewMoreButton, e => {
            const $button = $(e.currentTarget);
            const $spinner = $('<div class="js-store-search-spinner c-store-search-results__spinner"></div>');

            // Append spinner next to the button and show it
            $button.after($spinner);
            $spinner.show();

            setTimeout(() => {
                // Find the next 3 hidden store locations
                const $nextStores = $('.js-accordion-item.u-remove').slice(0, 3);
                
                $nextStores.each(function(index, element) {
                    $(element).removeClass('u-remove').hide().fadeIn(500);
                });

                // Add new markers for newly visible stores
                const allVisibleStores = document.querySelectorAll('.js-accordion-item:not(.u-remove)');
                this.addMarkersToMap(allVisibleStores);

                // Hide spinner after loading
                $spinner.remove();

                // If no more hidden items, hide the button
                if ($('.js-accordion-item.u-remove').length === 0) {
                    $button.fadeOut();
                }
            }, 600);
        });

        $(window).on('load resize', this.setMinHeight);

        // Handle accordion click - focus map on selected store
        $resultsSection.on('click', '.js-accordion-header', function () {
            const $currentItem = $(this).closest('.js-accordion-item');
            const $currentAccordionToggleText = $currentItem.find('.js-store-results-toggle-text');
            const storeIndex = parseInt($currentItem.attr('data-index')) - 1;
        
            // Close all other accordions and reset their text
            $('.js-accordion-item').not($currentItem).removeAttr('open')
                .find('.js-store-results-toggle-text').text('View More');
        
            // Toggle text based on open state
            if ($currentItem.attr('open')) {
                $currentAccordionToggleText.text('View More');
            } else {
                $currentAccordionToggleText.text('Hide Details');
                // Focus map on this store location
                findAStore.focusMarker(storeIndex);
            }
        });
        
        $form.on('submit', e => {
            e.preventDefault();
            this.doSearch();
        });

        $useMyLocation.on('click', e => {
            e.preventDefault();

            // Get users current location from browser
            if (navigator.geolocation) {
                // Change text to show we're getting the location
                $useMyLocation.text('Getting your location...');

                // Get lat and lng from browser
                navigator.geolocation.getCurrentPosition(position => {
                    const lat = position.coords.latitude;
                    const lng = position.coords.longitude;

                    // Convert lat and lng to postcode
                    $.ajax({
                        url: 'https://maps.googleapis.com/maps/api/geocode/json',
                        data: {
                            latlng: `${lat},${lng}`,
                            key: WP.gmaps_api_key,
                        },
                    }).done(response => {
                        if (!response.results || response.results.length === 0) {
                            alert("Sorry, we couldn't retrieve address details. Please try again.");
                            return;
                        }
                    
                        const addressComponents = response.results[0].address_components;
                    
                        if (!addressComponents) {
                            alert("Sorry, we couldn't find address details. Please try again.");
                            return;
                        }
                    
                        let postcodeComponent = null;
                    
                        for (let i = 0; i < addressComponents.length; i++) {
                            if (addressComponents[i].types.includes("postal_code")) {
                                postcodeComponent = addressComponents[i];
                                break;
                            }
                        }
                    
                        if (!postcodeComponent) {
                            alert("Sorry, we couldn't find your postcode. Please search using a postcode.");
                            return;
                        }
                    
                        const postcode = postcodeComponent.long_name;

                        if (!postcode) {
                            alert("Sorry, we couldn't find your postcode. Please search using a postcode.");
                            return false;
                        } else {
                            // Set postcode in form and submit
                            $('input[name="postcode"]').val(postcode);
                            this.doSearch();
                            $useMyLocation.text('We have found your location.');
                        }
                    });
                });
            } else {
                alert("Geolocation is not supported by this browser. Please search using a postcode.");
            }
        });
    }
};

module.exports = findAStore;